var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"slider"},[_c('Slider',{attrs:{"value":_vm.items,"display-thumbnail":true,"manual-navigation":true,"captionPlacement":'inside'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }